<template>
  <div v-if="showBanner" class="company-banner">
    <img
      :src="bannerUrl"
      :alt="$t('CompanyBanner.alt')"
      class="company-banner__img"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import { BANNER_EVENT, loadBannerFromStorage } from "@/_helpers";
export default {
  name: "CompanyBanner",
  data() {
    return {
      currentBannerUrl: loadBannerFromStorage(),
    };
  },
  computed: {
    ...mapState("utente", ["user"]),
    bannerUrl() {
      return this.currentBannerUrl;
    },
    showBanner() {
      if (!this.bannerUrl || !this.user || this.user.type !== 1) {
        return false;
      }

      const activeServices =
        this.user.my_company && this.user.my_company.active_services
          ? this.user.my_company.active_services
          : [];

      return activeServices.some((service) => service.position_ref === 16);
    },
  },
  created() {
    window.addEventListener(BANNER_EVENT, this.handleBannerChange);
  },
  beforeDestroy() {
    window.removeEventListener(BANNER_EVENT, this.handleBannerChange);
  },
  methods: {
    handleBannerChange(event) {
      this.currentBannerUrl = event.detail ? event.detail.bannerUrl : null;
    },
  },
};
</script>
<style scoped>
.company-banner {
  width: 100%;
  overflow: hidden;
  line-height: 0;
}
.company-banner__img {
  width: 100%;
  height: auto;
  display: block;
}
</style>
